<template>
  <div class="h5-transfer">
    <div class="open-other-app" id="openOtherApp" @click="arouseApp"></div>
    <div class="page-loading" v-if="loading">
      <img src="https://coolcdn.igetcool.com/p/2022/2/6a240f979f79dc51505479aceb597a13.gif" alt="">
    </div>
    <!-- 拉起小程序后，展示的页面 -->
    <div class="after-mp-show" v-if="afterMpShow">
      <div class="mp-content">
        <div class="logo">
          <img src="https://coolcdn.igetcool.com/p/2021/4/617d9094488a36d3512669b0980f4541.png?_286x76.png" alt="">
        </div>
        <div class="mp-button" @click="openWXMiniApp">打开小程序</div>
      </div>
      <p class="mp-bottom">
        微信版本低于7.0.12，系统版本低于IOS10.3或者Android5.0，可能无法跳转，请更新微信或者系统至新版本
      </p>
    </div>
  </div>
</template>

<script>
/**
  h5中转页，
  支持功能：
  1、打开第三方app
  2、打开微信小程序
  */
import { env, coolHref, JS2Native, httpRequest } from '@igetcool/base-components';
import ArousalMiniApp from '@igc-lib/arousal-mini-app';

export default {
  name: 'h5Transfer',
  data() {
    const { type, transferUrl, appId, ghId, mode, changeSwitch } = this.$route.query;
    return {
      type, // 'app':打开第三方app；'miniApp':打开微信小程序
      appId,
      ghId,
      mode,
      transferUrl: decodeURIComponent(transferUrl),
      loading: true,
      afterMpShow: false,
      changeSwitch,   // 跳转小程序是否强切账号
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      switch (this.type) {
        case 'app':
          // 打开第三方app
          this.openOtherApp();
          break;
        case 'miniApp':
          // 打开微信小程序
          this.openWXMiniApp();
          break;
        default:
          break;
      }
    },
    // 唤起微信小程序
    async openWXMiniApp() {
      // const envVersion = process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? 'release' : 'trial';
      const envVersion = this.mode == 1 ? 'trial' : 'release';
      if (env.isApp && this.changeSwitch) { // app 以外环境无效
        const { data } = await JS2Native({
          name: 'getAppUserPid'
        });
        if (data) {
          const { data: info } = await JS2Native({
            name: 'getUserInfo'
          });
          let token = info['App-Token'];
          let res = await httpRequest.get(`/app-api-oauth-server/white/api/oauth/user/token/get.json`, {
            token,
            userId: data,
          }, {
            forceAjax: true,
          });
          if (res.code == 10000) {
            let jwtToken = res.data.appOauth;
            this.transferUrl = `${this.transferUrl}${this.transferUrl.includes('?') ? '&' : '?'}userId=${data}&jwtToken=${jwtToken}`;
          }
        }
      }
      ArousalMiniApp({ ghId: this.ghId || '', appId: this.appId, transferUrl: this.transferUrl, envVersion: envVersion },
        res => {
          setTimeout(() => {
            this.loading = false;
            this.afterMpShow = true;
          }, 500);
        });
    },
    // 打开第三方app
    openOtherApp() {
      this.$nextTick(() => {
        document.getElementById('openOtherApp').click();
      });
    },
    // 多次decode,直到'://'出现
    loopDecode(url) {
      let resultUrl = url;
      let cycles = 0;
      // 判断跳转的URL 含有'://'或者循环10次，都要跳出循环
      while (resultUrl.indexOf('://') == -1 && cycles < 10) {
        cycles++;
        resultUrl = decodeURIComponent(resultUrl);
      }
      if (resultUrl.indexOf('://') != -1) {
        return resultUrl;
      } else {
        return false;
      }

    },
    // 唤起第三方app
    arouseApp() {
      const arouseUrl = this.loopDecode(this.transferUrl);
      // 返回false时，不做跳转，返回上一页
      if (!arouseUrl) {
        if (env.isApp) {
          JS2Native({
            name: 'closeWindow',
          });
        } else {
          this.$router.go(-1);
        }
      }
      coolHref(arouseUrl).then(() => {
        if (env.isApp) {
          JS2Native({
            name: 'closeWindow',
          });
        } else {
          this.$router.go(-1);
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.h5-transfer {
  .open-other-app {
    width: 1px;
    height: 1px;
    position: fixed;
    top: -1px;
    left: -1px;
  }
  .page-loading {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1rem;
      height: 1rem;
    }
  }

  .after-mp-show {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    position: relative;
    .mp-content {
      width: 80vw;
      margin: 0 auto;
      position: absolute;
      left: calc(50% - 40vw);
      bottom: 50vh;

      .logo {
        display: flex;
        justify-content: center;
        margin-bottom: 0.4rem;
        img {
          width: 80%;
        }
      }
      .mp-button {
        margin: 0 auto;
        color: #fff;
        padding: 0.1rem 0.2rem;
        border-radius: 0.04rem;
        background-color: #ff5f2e;
        font-size: .16rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .mp-bottom {
      position: absolute;
      bottom: 0.2rem;
      left: 0.2rem;
      right: 0.2rem;
      color: #a9b1b8;
      text-align: center;
      font-size: .1rem;
      line-height: .2rem;
    }
  }
}

@media (min-width: 600px) {
  .mp-content, .mp-bottom {
    transform-origin: bottom center;
    transform: scale(0.6);
  }
}
</style>
